<div class="main-container" @fadeIn>
	<div class="binder-heading-container">
		<div class="name-container">
			<span class="site-name">{{ binderDetails?.accountSiteName }}</span>
			<span class="resource-name">{{ binderDetails?.accountSiteResourceName }}</span>
		</div>
		<div class="binder-actions-container">
			<div *ngIf="!binderDetails.isYearless" class="year">{{ binderFormGroup.get('year').value }}</div>
			<div *ngIf="!isSession" class="filter-trigger">
				<button mat-icon-button (click)="onFilterClick(); $event.stopPropagation();"><mat-icon
						[class.filtered]="isBinderFiltered">filter_list</mat-icon></button>
			</div>

			<div class="menu-trigger">
				<button mat-icon-button
					(click)="isDropdownMenuOpen = !isDropdownMenuOpen; $event.stopPropagation();"><mat-icon>menu</mat-icon></button>
			</div>

			<div class="dropdown-menu" (click)="$event.preventDefault(); $event.stopPropagation();" @fadeIn @fadeOut
				*ngIf="isDropdownMenuOpen">
				<app-loader [isInline]="true" *ngIf="hasAddToBinderAccess === null"></app-loader>

				<button mat-flat-button (click)="isDropdownMenuOpen = false;" 
					*ngIf="!isSession
						&& ((!!hasAddToBinderAccess && isBinderAndCustomerLegacy)
							|| (!isBinderAndCustomerLegacy && hasWorkToDoJob === null)
							|| (!isBinderAndCustomerLegacy && hasWorkToDoJob !== null && !!hasAddToBinderAccess))"
					(click)="onAddToBinderClick()" @fadeIn @fadeOut>
					<mat-icon class="svg-icon" [svgIcon]="'add_to_binder'"></mat-icon>
					<span>Add to Binder</span>
				</button>

				<!-- <button mat-flat-button (click)="isDropdownMenuOpen = false; openEditBinderModal()" [disabled]="isDataLoading" @fadeIn @fadeOut>
					<mat-icon class="svg-icon" [svgIcon]="'edit_binder'"></mat-icon>
					<span>Edit Binder</span>
				</button> -->

				<button mat-flat-button 
					*ngIf="!isSession"
					(click)="isDropdownMenuOpen = false; openSendDocumentationModal()"
					[disabled]="isDataLoading" @fadeIn @fadeOut>
					<mat-icon class="svg-icon" [svgIcon]="'send-mail'"></mat-icon>
					<span>Send Documentation</span>
				</button>

				<button mat-flat-button (click)="isDropdownMenuOpen = false;" 
					*ngIf="!isSession
							&& ((!!hasAddToBinderAccess && isBinderAndCustomerLegacy)
								|| (!isBinderAndCustomerLegacy && hasWorkToDoJob === null)
								|| (!isBinderAndCustomerLegacy && hasWorkToDoJob !== null && !!hasAddToBinderAccess))"
					(click)="onExportFilesClick()" [disabled]="isDataLoading" @fadeIn @fadeOut>
					<mat-icon class="svg-icon" [svgIcon]="'export_files'"></mat-icon>
					<span>Export Current Binder</span>
				</button>

				<button mat-flat-button (click)="isDropdownMenuOpen = false; openQRScansHistory()"
					*ngIf="!isSession && hasQRScansAccess"
					@fadeIn @fadeOut>
					<mat-icon class="svg-icon" [svgIcon]="'QR_History'"></mat-icon>
					<span>Show QR scans</span>
				</button>

				<div *ngIf="!binderDetails.isYearless" class="binder-menu-category-container">
					<p class="category-heading">Binder Years</p>

					<button mat-flat-button class="child-button"
						[class.selected]="binderFormGroup.get('year').value === year"
						*ngFor="let year of binderSetupData.years"
						(click)="binderFormGroup.get('year').setValue(year); isDropdownMenuOpen = false;">
						<span>{{ year }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="binder-selection-container">
		<div class="main-form">
			<form [formGroup]="binderFormGroup">
				<div class="selection-container">
					<mat-form-field>
						<mat-select formControlName="parent" [disabled]="isDataLoading">
							<ng-container *ngFor="let item of binderParents">
								<mat-option *ngIf="!isDataLoading" [value]="item">
									{{ item.binderName }}
								</mat-option>
							</ng-container>
						</mat-select>
					</mat-form-field>
				</div>

				<mat-form-field *ngIf="selectedBinderChildren?.length && !isDataLoading" class="child-form-field">
					<mat-select formControlName="child">
						<mat-option *ngFor="let item of selectedBinderChildren" [value]="item">
							{{ item.binderName }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</form>
		</div>
	</div>

	<div class="binder-document-container">
		<div class="document-unavailable brief-form-container" *ngIf="isDataLoading">
			<p>Loading documents...</p>
		</div>
		<app-loader [isInline]="true" *ngIf="!!selectedBinder && (isDataLoading || !!selectedDocument?.isLoading)"
			[isLoadingFailed]="isDocumentsLoadingFailed" [loaderMessage]="loaderMessage"
			[matIconFailed]="'error_outline'"></app-loader>
		<div class="document-unavailable brief-form-container"
			*ngIf="!!selectedBinder && !!selectedBinder.documents?.length && !!binderParents?.length && (isDataLoading || !selectedDocument || selectedDocument.isLoading)">
			<p>Loading document...</p>
		</div>
		<div class="document-unavailable brief-form-container"
			*ngIf="!!selectedBinder && !isDataLoading && !!binderParents?.length && !!selectedDocument && !selectedDocument.isLoading && selectedDocument.isNotExisting">
			<span><strong>{{ selectedDocument.documentDisplayName }}</strong></span>
			<p>File seems to be missing</p>
			<div class="document-unavailable-actions form-button-container">
				<button class="secondary" mat-raised-button [disabled]="disablePrevDocButton"
					(click)="loadDocument(selectedDocumentDetailsIndex - 1)">Previous</button>
				<button mat-raised-button [disabled]="disableNextDocButton"
					(click)="loadDocument(selectedDocumentDetailsIndex + 1)">Next</button>
			</div>
		</div>
		<div class="document-unavailable brief-form-container"
			*ngIf="!isDataLoading && !!binderParents?.length && selectedDocument?.isNotSupported">
			<span><strong>{{ selectedDocument.documentDisplayName }}</strong></span>
			<p>Preview not available for this document type.</p>
			<div class="document-unavailable-actions form-button-container">
				<button class="secondary" mat-raised-button [disabled]="disablePrevDocButton"
					(click)="loadDocument(selectedDocumentDetailsIndex - 1)">Previous</button>
				<button mat-raised-button
					[disabled]="((this.selectedDocumentDetailsIndex >= this.selectedBinder.documents.length - 1) || (this.selectedBinder.documents.length <= 1))"
					(click)="loadDocument(selectedDocumentDetailsIndex + 1)">Next</button>
				<button mat-raised-button
					*ngIf="this.binderDetails.isDocumentDownloadEnabled"
					(click)="downloadCurrentDocument()">Download</button>
			</div>
		</div>
		<ng-container *ngIf="!isDataLoading">
			<ng-container
				*ngIf="!!binderParents?.length && !!selectedDocument && !selectedDocument.isLoading && !selectedDocument.isNotExisting && !selectedDocument.isNotSupported">
				<app-document-viewer
					[documentDetails]="(this.selectedDocument && !this.selectedDocument.isNotExisting) ? this.selectedDocument : null"
					[afterWebViewerRender]="afterWebViewerRender.bind(self)"
					(documentNotSupported)="onDocumentNotSupported($event)">
				</app-document-viewer>
			</ng-container>
			<p *ngIf="!isDataLoading && (!!selectedBinder && !selectedBinder.documents?.length)">There are no documents
				in the current Binder Tab!</p>

			<h4 *ngIf="!isDataLoading && !binderParents?.length" class="empty-binder">
				<span>Collecting recent changes to your binder. Please refresh this tab in 5 minutes.</span>
				<br>
				<span>If you have any issues please contact Customer Support at 833.848.1100</span>
			</h4>
		</ng-container>
	</div>
</div>

<binder-send-documentation #sendDocumentation [years]="binderSetupData.years"
	[selectedYear]="binderFormGroup.get('year').value" [binderParents]="binderParents"
	[selectedBinderChildren]="selectedBinderChildren" [binderDetails]="binderDetails"
	[binderClassification]="binderClassification" [targetEmail]="targetEmailAddress.targetEmail"
	[binderContent]="binderContent">
</binder-send-documentation>

<binder-qr-scan-history #qrScanHistory [binderQRScanHistory]="binderQRScanHistory">
</binder-qr-scan-history>

<edit-binder #editBinder
	*ngIf="!isSession"
	[years]="binderSetupData.years" [selectedYear]="binderFormGroup.get('year').value"
	[binderClassification]="binderClassification" [binderDetails]="binderDetails">
</edit-binder>

<generic-modal #filterModal [hideOnBackdropClick]="false" class="binder-filter-modal">
	<ng-template #modalHeading>
		<h4>Documents Filter</h4>
		<hr>
	</ng-template>
	<ng-template #modalBody>
		<div class="filter-form">
			<form [formGroup]="filterBinderForm">
				<div class="filter-container">
					<div class="filter-item-label">Show Tabs with Docs only:</div>
					<mat-slide-toggle formControlName="showTabs" color="primary"
						[disabled]="isDataLoading"></mat-slide-toggle>
				</div>
				<div *ngIf="hasCustomerPermissionAIReviewRequired" class="filter-container">
					<div class="filter-item-label">Hide Pending Required Review Documents:</div>
					<mat-slide-toggle formControlName="hideReviewRequired" color="primary"
						[disabled]="isDataLoading"></mat-slide-toggle>
				</div>
				<div class="filter-container-item">
					<span>Only For {{binderDetails?.accountSiteResourceName}}:</span>
					<mat-form-field appearance="outline">
						<mat-select formControlName="asset" [disabled]="isDataLoading">
							<mat-option *ngFor="let item of documentAssets" [value]="item.accountSiteResourceId"
								(click)="$event.stopPropagation(); $event.preventDefault();">
								{{ item.name }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div *ngIf="availableTags" class="filter-container-item">
					<span>Show only for specific Document Tag:</span>
					<mat-form-field appearance="outline">
						<mat-select formControlName="expectationAssetTagId"
						class="tag-select-dropdown"
						[panelClass]="'tag-select-dropdown'"
						[disabled]="isDataLoading" 
						placeholder="-Any Tag-">
						<mat-select-trigger>{{selectedTag}}</mat-select-trigger>
							<mat-option [value]="null" (click)="$event.stopPropagation(); $event.preventDefault();">
								-Any Tag-
							</mat-option>
							<mat-option *ngFor="let item of availableTags" [value]="item.expectationAssetTagId"
								(click)="$event.stopPropagation(); $event.preventDefault();">
								<div class="tag-option">
									<span class ="tag-name"> {{ item.tag }} </span>									
									<span class="tag-service-contract"> {{item.projectName}} <span *ngIf="item.projectNumber" style="color: #4a73bf"> #{{item.projectNumber}}</span> </span>
								</div>
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="filter-container-item">
					<span> Show only following Document Types(s):</span>
					<mat-form-field appearance="outline">
						<mat-select formControlName="documentTypes" multiple [disabled]="isDataLoading"
							placeholder="- Any Document Type -" (openedChange)="onDocumentTypeChange($event)">
							<mat-option *ngFor="let docType of documentTypes" [value]="docType.documentTypeId"
								(click)="$event.stopPropagation(); $event.preventDefault()">
								{{ docType.name }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div *ngIf="isMeasurementAvailable" class="filter-container-item">
					<span> Show only for specific Measurements:</span>
					<mat-form-field appearance="outline">
						<mat-select formControlName="measurements" [disabled]="isDataLoading"
							(selectionChange)="onMeasurementChange($event.value)" placeholder="-Any Measurements-">
							<mat-option [value]="null" (click)="$event.stopPropagation(); $event.preventDefault();">
								-Any Document Reading-
							</mat-option>
							<mat-option *ngFor="let measurement of readingMeasurements" [value]="measurement" [disabled]="isDataLoading"
								(click)="$event.stopPropagation(); $event.preventDefault();">
								{{ measurement.measurementName }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div *ngIf="isMeasurementAvailable && selectedMeasurement?.serviceCategoryDocumentReadingId > 0"
					class="criteria-input-container">
					<mat-form-field class="criteria-dropdown" appearance="outline">
						<mat-select formControlName="readingCriteria"
							(selectionChange)="updateReadingValue($event.value)">
							<mat-option *ngFor="let criteria of readingCriterias" [value]="criteria">
								{{ criteria.criteria }}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<div class="input-container">
						<ng-container *ngIf="selectedCriteria && selectedCriteria?.isValueRequired">
							<ng-container *ngIf="selectedCriteria.isRangeValue; else singleInput">
								<div class="range-inputs">
									<mat-form-field class="input-field small-input" appearance="outline">
										<input matInput formControlName="readingValueStart" placeholder="Start Value"
											type="number">
									</mat-form-field>
									<span>and</span>
									<mat-form-field class="input-field small-input" appearance="outline">
										<input matInput formControlName="readingValueEnd" placeholder="End Value"
											type="number">
									</mat-form-field>
								</div>
							</ng-container>

							<ng-template #singleInput>
								<mat-form-field class="input-field single-input" appearance="outline">
									<input matInput formControlName="readingValue"
										[type]="isNumericCriteria() ? 'number' : 'textarea'" placeholder="Enter Value">
								</mat-form-field>
							</ng-template>
						</ng-container>
					</div>
				</div>

				<div class="date-pick">
					<mat-form-field class="calendar">
						<mat-label>From: <span *ngIf="!binderDetails.isYearless">(Begin Date:
								{{moment(minDate).format('MM/DD/YYYY')}})</span></mat-label>
						<input matInput [matDatepicker]="fromDate" formControlName="fromDate" [min]="minDate"
							[max]="maxFromDate">
						<mat-datepicker-toggle matSuffix [for]="fromDate"
							[disabled]="isDataLoading"></mat-datepicker-toggle>
						<mat-datepicker #fromDate [startAt]="minDate"></mat-datepicker>
						<button mat-button *ngIf="filterBinderForm.get('fromDate')?.value" matSuffix mat-icon-button
							aria-label="Clear" (click)="filterBinderForm.get('fromDate').reset()">
							<mat-icon>close</mat-icon>
						</button>
						<mat-error
							*ngIf="filterBinderForm?.get('fromDate')?.invalid && (filterBinderForm?.get('fromDate')?.dirty || filterBinderForm?.get('fromDate')?.touched)">Please
							select a valid date</mat-error>
					</mat-form-field>

				</div>
				<div class="date-pick">
					<mat-form-field class="calendar">
						<mat-label>To: <span *ngIf="!binderDetails.isYearless">(End Date:
								{{moment(maxDate).format('MM/DD/YYYY')}})</span></mat-label>
						<input matInput [matDatepicker]="toDate" formControlName="toDate" [min]="minToDate"
							[max]="maxDate">
						<mat-datepicker-toggle matSuffix [for]="toDate"
							[disabled]="isDataLoading"></mat-datepicker-toggle>
						<mat-datepicker #toDate></mat-datepicker>
						<button mat-button *ngIf="filterBinderForm.get('toDate')?.value" matSuffix mat-icon-button
							aria-label="Clear" (click)="filterBinderForm.get('toDate').reset()">
							<mat-icon>close</mat-icon>
						</button>
						<mat-error
							*ngIf="filterBinderForm?.get('toDate')?.invalid && (filterBinderForm?.get('toDate')?.dirty || filterBinderForm?.get('toDate')?.touched)">Please
							select a valid date </mat-error>
					</mat-form-field>
				</div>
			</form>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<button mat-raised-button type="button" class="cancel-button" (click)="onFilterCancel()">
			<span>Cancel</span>
		</button>
		<button mat-raised-button type="button" (click)="filterData()" [disabled]="!filterBinderForm.valid">
			<span>Apply</span>
		</button>
	</ng-template>
</generic-modal>

<generic-modal #binderRequestAccess [hideOnBackdropClick]="false" class="binder-request-access-info">
	<ng-template #modalHeading>
		<h4>Binder Request Access</h4>
		<hr>
	</ng-template>
	<ng-template #modalBody>
		<div>
			<span>This feature requires you to request access to this binder with <span style="font-weight:bold;">I have
					Work to do</span> option enabled. </span>
			<span>Do you want to go back to binder request page?</span>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<button mat-raised-button type="button" class="cancel-button" (click)="binderRequestAccess.hide()">
			<span>No</span>
		</button>
		<button mat-raised-button type="button" (click)="onBackToBinderRequest()">
			<span>Yes</span>
		</button>
	</ng-template>
</generic-modal>

<generic-modal #binderExportFilesWarning [hideOnBackdropClick]="false" class="binder-request-access-info">
	<ng-template #modalBody>
		<div>
			<span>Depending on Binder size, the export may take up to 1-2 hours to prepare the download link.</span>
			<br><span> Are you sure you want to proceed?</span>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<button mat-raised-button type="button" class="cancel-button" (click)="binderExportFilesWarning.hide()">
			<span>Cancel</span>
		</button>
		<button mat-raised-button type="button" (click)="onExportFilesConfirm()">
			<span>Submit</span>
		</button>
	</ng-template>
</generic-modal>
